export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Pakistan-a31e0fb7cc16fd4ec425964a8b142365.mp3";